import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { 
  Box, 
  Chip, 
  CircularProgress,  
  Table, 
  TableBody, 
  TableCell, 
  TableFooter, 
  TableHead, 
  TablePagination, 
  TableRow, 
  TableSortLabel, 
  Typography 
} from '@mui/material';

import useTablePaginationInit from '../../../../../components/hooks/useTablePaginationInit';
import TablePaginationActions from '../../../../../components/utils/TablePaginationActions';
import Copyable from '../../../../../components/utils/Copyable';
import TopBar from '../../../../../components/utils/TopBar';
import NA from '../../../../../components/utils/NA';

import { 
  GetCampaignsBIZfusionWyzia 
} from '../../../../../redux/actions/business/fusion/wyzia/campaignsActions';

import CampaignsModal from './CampaignsModal';


const CampaignsPage = () => {
  const dispatch = useDispatch();
  const state = useSelector(state => state["business.fusion.wyzia"]);
  const [loading, setLoading] = useState(true);
  const [sort, setSort] = useState("createdAt");
  const [sortDirection, setSortDirection] = useState("desc");
  const [campaignsModalOpen, setCampaignsModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [update, setUpdate] = useState();

  const [campaignsList, setCampaignsList] = useState([]);
  const [campaignsTotal, setCampaignsTotal] = useState(0);

  const [
    page, 
    rowsPerPage, 
    handleChangePage, 
    handleChangeRowsPerPage
  ] = useTablePaginationInit();

  const tableHeadingsList = [
    {
      label: "Id",
      sort: null,
    },
    {
      label: "Access Key",
      sort: null,
    },
    {
      label: "Name",
      sort: null,
    },
    {
      label: "Country",
      sort: null,
    }, 
    {
      label: "AllowSandbox",
      sort: null,
    },
    {
      label: "Due Dilligence",
      sort: null,
    },
    {
      label: "Active",
      sort: null,
    },
    // {
    //   label: null,
    //   sort: null,
    // }
  ];

// {
//     "id": "798e44c8-d3ce-4882-aa06-672d99d1ac53",
//     "name": "Test 2",
//     "country": null,
//     "urls": {
//         "listenerUrl": null,
//         "allowSupervisorsToEditListenerUrl": false,
//         "successUrl": null,
//         "failureUrl": null,
//         "approvedMerchantUrls": null
//     },
//     "accessKey": {
//         "currentAccessKey": "edab56ad-e498-4584-a299-70f9816020e8",
//         "expiringAccessKey": ""
//     },
//     "allowSandbox": true,
//     "active": false,
//     "dueDilligence": false
// }

  const handleSort = (value) => {
    setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    setSort(value);
  };

  useEffect(() => {
    handleGetCampaigns();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, rowsPerPage]);

  async function handleGetCampaigns(customloading) {
    dispatch(GetCampaignsBIZfusionWyzia(page+1, rowsPerPage, "", customloading ? customloading : setLoading));
  };

  useEffect(() => {
    try {
      console.log(state.campaignsList.data.items)
      formatCampaignsList(state.campaignsList.data.items || []);
      setCampaignsTotal(state.campaignsList.data.total || 0);
    } catch (err) {}
  }, [state]);

  const formatCampaignsList = (list) => {
    setCampaignsList(list);
  };

  return (
    <Box>

      <CampaignsModal
        open={campaignsModalOpen}
        setOpen={setCampaignsModalOpen}
        title={modalTitle}
        update={update}
        handleGet={handleGetCampaigns}
      />
    
      <TopBar
        title={"Campaigns"}
        button1Text={"Add campaign"}
        button1OnClick={() => {
          setUpdate({
            defaultMode: 1
          });
          setModalTitle("Add campaign");
          setCampaignsModalOpen(!campaignsModalOpen);
        }}
        />

      {
        loading
        ?
        <Box height={"300px"} className="flexCenterCenterRow">
          <CircularProgress />
        </Box>
        :
          campaignsList.length === 0
          ?
          <Box height={"300px"} className="flexCenterCenterRow">
            <Typography>No campaign found</Typography>
          </Box>
          :
          <Table className="block">
            <TableHead>
              <TableRow>
                {
                  tableHeadingsList.map((heading, headingIndex) => (
                    heading.sort === null
                    ?
                    <TableCell
                      key={headingIndex}>{heading.label}</TableCell>
                    :
                    <TableCell
                      key={headingIndex}>
                      <TableSortLabel
                        active={sort === heading.sort ? true : false}
                        direction={sortDirection}
                        onClick={() => {
                          handleSort(heading.sort);
                        }}
                      >
                        {heading.label}
                      </TableSortLabel>
                    </TableCell>
                  ))
                }
              </TableRow>
            </TableHead>
            <TableBody>
              {
                campaignsList.map((row, index) => (
                  <TableRow 
                    key={index}>
                    <TableCell>
                      <Typography
                        variant='caption'
                        color={"grey"}>
                        <Copyable>
                          {row.id}
                        </Copyable>
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        variant='caption'>
                        <Copyable>
                          {row.accessKey.currentAccessKey || <NA />}
                        </Copyable>
                      </Typography>
                    </TableCell>
                    <TableCell>
                      {row.name || <NA />}
                    </TableCell>
                    <TableCell>
                      {row.country || <NA />}
                    </TableCell>
                    <TableCell>
                      {row.allowSandbox ? "Yes" : "No" || <NA />}
                    </TableCell>
                    <TableCell>
                      {row.dueDilligence ? "Yes" : "No" || <NA />}
                    </TableCell>
                    <TableCell>
                      <Chip
                        size='small'
                        label={row.active ? "Active" : "Inactive" || <NA />}
                        color={row.active ? "success" : "error" || <NA />}
                        />
                      
                    </TableCell>

                  </TableRow>
                ))
              }
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  sx={{ borderBottom: 0 }}
                  rowsPerPageOptions={[5, 10, 25, 50, 100]} 
                  colSpan={10}
                  count={campaignsTotal}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  SelectProps={{
                    inputProps: {
                      'aria-label': 'rows per page'
                    },
                    native: true
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                  />
              </TableRow>
            </TableFooter>
          </Table>
      }
    </Box>
  )
}

export default CampaignsPage;